var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F8F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(6.66602 6.66699)",
    fill: "#F8F9FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.666,
    cy: 24.667,
    r: 17.5,
    stroke: "#848FA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6476 16.5587C21.4147 16.61 21.1233 16.7143 20.9847 16.7961C20.9153 16.837 20.8528 16.8704 20.8458 16.8704C20.8131 16.8704 20.4833 17.1539 20.3558 17.2917C20.0066 17.669 19.8185 18.0723 19.7499 18.5909C19.731 18.7334 19.7063 18.8592 19.6949 18.8705C19.6835 18.8819 19.0559 18.8951 18.3003 18.8999C16.9781 18.9084 16.9198 18.9107 16.7515 18.9625C16.3285 19.0925 16.0485 19.2483 15.7662 19.5106C15.4343 19.8189 15.2377 20.1239 15.0847 20.5675L15.0029 20.8048V25.9507C15.0029 31.216 15.0031 31.2281 15.0907 31.4463C15.1017 31.4738 15.1294 31.5468 15.1523 31.6087C15.3871 32.2425 15.9618 32.775 16.6572 33.0033C16.9878 33.1119 16.9027 33.1108 24.6078 33.1027L31.9644 33.095L32.1586 33.0382C33.115 32.759 33.7722 32.0216 33.9244 31.0571C33.9416 30.9475 33.9503 29.256 33.9503 25.9861C33.9503 20.7414 33.9545 20.9371 33.8324 20.5425C33.6206 19.8586 33.0083 19.2319 32.3391 19.0143C32.0199 18.9105 32.0316 18.9113 30.6038 18.8961L29.2182 18.8813L29.187 18.644C29.1352 18.2496 29.0673 18.0373 28.8954 17.7323C28.6573 17.3096 28.3222 16.9898 27.8916 16.7744C27.6517 16.6544 27.5065 16.6046 27.257 16.5568C26.991 16.5059 21.8797 16.5077 21.6476 16.5587ZM23.9957 22.2532C23.4382 22.3381 22.9306 22.5312 22.4969 22.8234C21.6998 23.3605 21.1873 24.1106 20.9576 25.0764C20.905 25.2976 20.8983 25.3848 20.8987 25.8383C20.8991 26.3666 20.9143 26.4859 21.0322 26.8874C21.3742 28.0522 22.3272 28.9889 23.5211 29.3335C23.9134 29.4467 24.5818 29.4938 24.9803 29.4362C25.9897 29.2904 26.843 28.7793 27.4471 27.9587C27.5066 27.8778 27.5554 27.8071 27.5554 27.8017C27.5554 27.7963 27.5984 27.7204 27.651 27.6331C27.8363 27.3258 27.984 26.9143 28.0845 26.4253C28.1262 26.2226 28.1259 25.4703 28.0841 25.2637C28.0407 25.0492 27.9571 24.723 27.9248 24.6418C27.9105 24.606 27.8906 24.5543 27.8805 24.5268C27.823 24.3707 27.6326 24.0104 27.5013 23.8093C27.3118 23.5191 26.8263 23.0299 26.5437 22.8444C26.1828 22.6076 25.6864 22.3892 25.3375 22.3138C24.8844 22.2158 24.388 22.1934 23.9957 22.2532Z",
    fill: "#848FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2bc12085dffe8e959eedd22469182dd7.svg";
export { ForwardRef as ReactComponent };